export default "__VITE_ASSET__CTBZpOeL__"